module.exports = __webpack_public_path__ + "img/cyber-security-icon.svg";